/**
 * Centralized API Configuration
 * Single source of truth for API URLs and configuration
 */

// Validate and export backend URL
export const BACKEND_URL = (() => {
  const url = window.__BACKEND_URL__;
  
  // Fail loudly on missing backend URL in development
  if (!url && process.env.NODE_ENV === 'development') {
    console.error(
      '❌ REACT_APP_BACKEND_URL is not defined. ' +
      'Please check your .env file.'
    );
  }
  
  // Provide helpful feedback
  if (!url) {
    console.warn(
      '⚠️  REACT_APP_BACKEND_URL is not defined. ' +
      'API calls will fail. Check your environment configuration.'
    );
  } else {
  }
  
  return url || '';
})();

// Determine if we're using cookies (local dev) or tokens (preview/production)
export const USES_COOKIES = BACKEND_URL.includes('localhost') || BACKEND_URL.includes('127.0.0.1');

// API endpoints
export const API_ENDPOINTS = {
  // Auth
  AUTH_LOGIN: '/api/auth/login',
  AUTH_REGISTER: '/api/auth/register',
  AUTH_LOGOUT: '/api/auth/logout',
  AUTH_ME: '/api/auth/me',
  AUTH_REFRESH: '/api/auth/refresh',
  AUTH_FORGOT_PASSWORD: '/api/auth/forgot-password',
  AUTH_RESET_PASSWORD: '/api/auth/reset-password',
  
  // Protected routes that should trigger auth redirect on 401
  PROTECTED_PREFIXES: [
    '/api/dashboard',
    '/api/profile',
    '/api/account',
    '/api/messages',
    '/api/saved',
    '/api/subscriptions',
    '/api/casting-call/applications',
  ],
  
  // Public routes that should NOT trigger auth redirect on 401
  PUBLIC_PREFIXES: [
    '/api/auth/me',  // Auth check should fail silently
    '/api/talent',
    '/api/casting-calls',
    '/api/casting-professionals',
    '/api/agents',
    '/api/services',
    '/api/companies',
    '/api/crew',
    '/api/events',
    '/api/news',
    '/api/settings/branding',
  ],
};

/**
 * Check if a URL is a public endpoint
 */
export function isPublicEndpoint(url) {
  if (!url) return false;
  return API_ENDPOINTS.PUBLIC_PREFIXES.some(prefix => url.includes(prefix));
}

/**
 * Check if current page is an auth page (login/register)
 */
export function isAuthPage(pathname = window.location.pathname) {
  return pathname.includes('/login') || pathname.includes('/register');
}

/**
 * Get full API URL
 */
export function getApiUrl(endpoint) {
  if (!BACKEND_URL) {
    throw new Error('Backend URL is not configured');
  }
  return `${BACKEND_URL}${endpoint}`;
}
